import React from "react";
var __jsx = React.createElement;
import { ELSDivider } from "../../common/elsevier/Divider/Divider";
import { ELSGrid } from "../../common/elsevier/Grid/Grid";
import { ELSSkeleton } from "../../common/elsevier/Skeleton/Skeleton";
function Loading() {
  return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    rowSpacing: 2,
    spacing: 2
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 2,
    alignItems: "center",
    className: "back-to-results--grid"
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 10,
    alignItems: "center",
    className: "article-toolbar--grid"
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 2,
    className: "article-navigation--grid"
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 10
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 9,
    className: "main-article--grid"
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rectangular",
    height: 190
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 3,
    className: "citation-info--grid"
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ELSDivider, {
    height: 6
  }), " ", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 8,
    className: "record-body--grid"
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "rectangular",
    height: 190
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    lg: 4,
    className: "related-docs--grid"
  }, /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  }), /*#__PURE__*/React.createElement(ELSSkeleton, {
    variant: "text",
    height: 40
  })))));
}
export default Loading;